<template src="./range-field.html"></template>

<script lang="ts">
import fieldGroupPropsMixin from './FieldGroupPropsMixin.vue'
import FieldGroup from './FieldGroup.vue'

export default {
  data() {
    return {
      value: ''
    }
  },
  props: {
    describedbyId: {
      type: String,
      default: () => `tt-hint-${Math.random().toString(16).slice(5)}`
    },
    groupName: { type: String, required: true },
    modelValue: [String, Number],  // type could be number or string
    showMiddleLabel: Boolean,
    valueDefinitions: { type: Array }
  },
  emits: ['update:modelValue'],
  mixins: [fieldGroupPropsMixin],
  components: { 'tt-field-group': FieldGroup },
  computed: {
    textLabels() {
      const valueDefs = this.valueDefinitions
      return valueDefs.filter((def, i) => {
        // if first or last label
        if (i === 0 || i === valueDefs.length - 1) {
          return true
        } else if (this.showMiddleLabel && i === (valueDefs.length === 3 ? 1 : 2)) {
          // middle label is index 1 if there are 3, index 2 if there are 5
          return true
        }
        return false
      }).map(def => def.label)
    }
  },
  methods: {
    setValue() {
      if (this.modelValue !== undefined) {
        this.value = this.modelValue
      }
    }
  },
  watch: {
    modelValue() {
      this.setValue()
    },
    value() {
      this.$emit('update:modelValue', this.value)
    }
  },
  created() {
    this.setValue()
  }
}
</script>

<style lang="scss" src="./range-field.scss"></style>
